import * as lodash from 'lodash';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  ApiSetFavoriteListGet,
  ApiSetFavoriteGet,
  ApiSetFavoriteCreate,
  ApiSetFavoriteUpdate,
  ApiSetFavoriteDelete,
} from '../../../api/front/favorite-set/api-favorite-set';
import { ResponseBase } from '../../../api/response-base';
import { useAppSelector } from '../../../app/hooks';
import folderClose from '../../../assets/img/icon/folder-close-black.svg';
import folderOpen from '../../../assets/img/icon/folder-open-black.svg';
import {
  SetFavoriteItemResponse,
  SetFavoriteItemListResponse, SetFavoriteItemRequest,
} from '../../../models/api/front/favorite-set';
import { apiActions } from '../../../slices/api-slice';
import { favoriteSetActions, FavoriteSetItem } from '../../../slices/favorite-set-slice';
import { toolbarActions } from '../../toolbar/slice/toolbar-slice';
import { Button } from '../../ui/button/button';
import { SwitchIcon } from '../../ui/switch-icon/switch-icon';
import { dialogActions } from '../slice/dialog-slice';
import { AddFolder } from './add-folder';
import { ChangeFavoriteSetName } from './change-favorite-set-name';
import './favorite-set-config.scss';
import { ApiFavoriteFolderDelete, ApiFavoriteFolderPost } from '../../../api/front/favorite-folder/api-favorite-folder';
import { FavoriteFolderListItem } from '../../../models/api/front/favorite-folder';
import { FavoriteTemplateItem } from '../../../slices/favorite-template-slice';
import { Input } from '../../ui/input/input';
import { LoadingPopup } from '../../ui/loading/loading-popup';
import { folder } from 'jszip';
import { FavoriteSelectorConfig } from './favorite-selector-config';
import { OrderInfoDataXml } from '../../../xml/class/order/order-info-data-xml';
import { createOrderActions } from '../../../slices/create-order-slice';
import { FavoriteBrandConfig } from './favorite-brand-config';
import { ordersActions, OrdersSliceState } from '../../../slices/orders-slice';
import { ApiFavoriteDataGet, FavoriteDataGetResponse } from '../../../api/front/favorite/api-favorite';
import { OrderPartsXml } from '../../../xml/class/order/order-parts-xml';
import { OrderPartsDataXml } from '../../../xml/class/order/order-parts-data-xml';
import { OrderPageXml } from '../../../xml/class/order/order-page-xml';
import { OrderPageDataXml } from '../../../xml/class/order/order-page-data-xml';
import { XmlFactory } from '../../../xml/factory/xml-factory';
import { XmlClass } from '../../../xml/class/xml-class';
import {
  XmlStructureOrderInfoData, XmlStructureOrderPage,
  XmlStructureOrderParts,
  XmlStructureOrderPartsData,
} from '../../../xml/model/xml-structure-model';
import { VisibleConditionValueGetter } from '../../../manager/visible-condition-value-getter';
import { ordersDataActions } from '../../../slices/orders/orders-data-slice';
import { CreateOrderItemData } from '../../../models/create-order/create-order-item-data';
import { orderLockActions } from '../../../slices/lock-order-slice';
import { itemDetailItemData } from '../../../models/create-order/item-detail-item-data';
import { coverItemData } from '../../../models/create-order/cover-item-data';
import { genuineItemData } from '../../../models/create-order/genuine-item-data';
import { descriptionInfoItemData } from '../../../models/create-order/description-info-item-data';
import { optionItemData } from '../../../models/create-order/opion-item-data';
import { useParams } from 'react-router-dom';
import { PathParams, RoutingPath } from '../../../routes/routing-path';
import { OptionRequireAlert } from '../../pages/create-order/create-order';
import { localStorageActions } from '../../../slices/local-storage-slice';
import { push } from 'connected-react-router';
import { xmlActions } from '../../../xml/slice/xml-slice';
import { DateFormatter } from '../../../utilities/date-formatter';
import { convertResponseToOrderData } from '../../pages/order-preparation/convert-response-to-order-data';
import { store } from '../../../app/store';
import {ApiBoardOptionInfos} from "../../../api/back/create-order/board-option-info/api-board-option-infos";
import {BoardOptionInfosResponse} from "../../../models/api/back/create-order/board-option-infos";
import {
  ApiOptionMaterialFilters
} from "../../../api/back/create-order/option-material-filters/api-option-material-filters";
import {OptionMaterialFiltersResponse} from "../../../models/api/back/create-order/option-material-filters";
import {
  ApiOptionParts1,
  ApiOptionParts2,
  ApiOptionParts3
} from "../../../api/back/create-order/option-parts/api-option-parts";
import {OptionPartsResponse} from "../../../models/api/back/create-order/option-parts";
import {ApiProductDetail} from "../../../api/back/create-order/product-detail/api-product-detail";
import {ProductDetailResponse} from "../../../models/api/back/create-order/product-detail";
import {ApiOptionFoilStampings} from "../../../api/back/create-order/option-foil-stampings/api-option-foil-stampings";
import {ApiLaminates} from "../../../api/back/create-order/laminates/api-laminates";
import {LaminatesResponse} from "../../../models/api/back/create-order/laminates";
import {OptionFoilStampingsResponse} from "../../../models/api/back/create-order/option-foil-stampings";
import {ApiPageDataTypes} from "../../../api/back/create-order/page-data-types/api-page-data-types";
import {PageDataTypesResponse} from "../../../models/api/back/create-order/page-data-types";
import {ApiEndpaper} from "../../../api/back/create-order/endpaper/api-endpaper";
import {EndpaperResponse} from "../../../models/api/back/create-order/endpaper";


type ChildContentProps = {
  kijshopCd?: string,
  content: FavoriteSetItem,
  selected: boolean,
  onClick: () => void,
};

// - １項目分の表示 -
const ChildContent = (props: ChildContentProps) => {
  const { content, selected, onClick } = props;
  return (
    <div
      className={`favorite_set_config__table__body__row${selected ? ' selected' : ''}`}
      onClick={onClick}
    >
      {/* アイコンを表示していたdivは、レイアウト崩れ防止のために残す（中身は空） */}
      <div className="favorite_set_config__table__body__row__icon"></div>

      {/* セット商品名を表示します */}
      <div className="favorite_set_config__table__body__row__data">
        {content.name.replaceAll(' ', '\u00A0')}
      </div>
    </div>
  );
};

type FavoriteSetConfigProps = {
  kijshopCd: string,
  shopOrderId: string,
  // - 閉じるボタンの表示名 -
  closeButtonLabel?: string,
  // - 閉じるボタンcallback -
  closeButtonCallback?: () => void,
  // - OKボタンcallback -
  okButtonCallback?: (id: string) => void,
  // - お気に入り商品保存ダイアログか -
  isSaveDialog?: boolean,
  // - OKボタン押下フラグ -
  disabled?: boolean,
  // - 注文画面でセット選択用の項目を追加
  mode?: 'disp' | 'select';
};
export const FavoriteSetCreate = (props: FavoriteSetConfigProps) => {
  const { kijshopCd, shopOrderId, closeButtonLabel, closeButtonCallback, okButtonCallback, isSaveDialog, disabled: _disabled } = props;
  // - Hooks -
  const dispatch = useDispatch();
  const { setList, selectSet, setDataList, visibleCondition, xml, order, data } = useAppSelector((state) => ({
    setList: state.favoriteSet.setList,
    selectSet: state.favoriteSet.selectSet,
    setDataList: state.favoriteSet.setDataList,
    visibleCondition: state.createOrder.visibleCondition,
    xml: state.xml[shopOrderId],
    order: state.order,
    data: state.orderData,
  }), lodash.isEqual);

  // - State -
  const [treeIconWidth, setTreeIconWidth] = useState(0);
  const [selectedId, setSelectedId] = useState('');
  const [folderList, setFolderList] = useState<FavoriteFolderListItem[]>([]);
  const [favoriteDataList, setFavoriteDataList] = useState<FavoriteSetItem[]>([]);
  const [disabled, setDisabled] = useState(_disabled);
  const [childrenOpenCountArr, setChildrenOpenCountArr] = useState<number[]>([]);
  const [loading, setLoading] = useState(false);
  const [creating, setCreating] = useState(false);
  const [loadingInit, setLoadingInit] = useState(true);
  const [createOrderCount, setCreateOrderCount] = useState(0);
  const [totalOrderCount, setTotalOrderCount] = useState(0);
  useEffect(() => {
    setDisabled(_disabled);
  }, [_disabled]);

  // - Callback -
  // -- 閉じるボタン押下 --
  const handlerClickClose = useCallback(() => {
    dispatch(dialogActions.pop());
    dispatch(favoriteSetActions.setSelectSet(undefined));
  }, []);

  // -- 削除ボタン(選択したセットの削除) --
  const handlerCLickDelete = useCallback(() => {
    if (selectSet) {
      // dispatch(dialogActions.pop());
      dispatch(dialogActions.pushMessage({
        title: '確認',
        message: [
          `お気に入り商品のセット名「${selectSet.name}」のセット情報を削除します。`,
          'よろしいですか？'
        ],
        buttons: [
          {
            label: 'いいえ',
            callback: () => {
              dispatch(dialogActions.pop());
              // moveToConfigDialog();
            },
          },
          {
            label: 'はい',
            callback: () => {
              dispatch(dialogActions.pop());
              setLoading(true);
              if (selectSet.type === 'set') {
                dispatch(apiActions.run(
                  new ApiSetFavoriteDelete(selectSet.id, { kijshopCd }),
                  {
                    onSuccess: () => {
                      dispatch(favoriteSetActions.setSelectSet(undefined));
                      handlerCreateListData();
                      setLoading(false);
                      // moveToConfigDialog();
                    },
                  },
                ));
              }
            },
          },
        ],
      }));
    }
  }, [selectSet, dispatch, kijshopCd]);

  // -- 編集ボタン(選択したセットの編集) --
  const handlerClickSetUpdate = useCallback(() => {
    if (selectSet) {
      dispatch(dialogActions.push({
        title: 'お気に入りセット商品保存',
        element: (
          <FavoriteSelectorConfig
            kijshopCd={kijshopCd}
            mode="edit"
            initialSetId={selectSet!.id}           // 編集したいセットのID
            okButtonCallback={() => refreshList()} // 一覧更新とダイヤログ閉じる
          />
        ),
      }));
    }
  }, [selectSet]);

  // -- セット登録ボタン --
  const handlerClickSetRegister = useCallback(() => {
    dispatch(dialogActions.push({
      title: 'お気に入りセット商品保存',
      element: <FavoriteSelectorConfig
        kijshopCd={kijshopCd}
        okButtonCallback={() => refreshList()} // 一覧更新とダイヤログ閉じる
      />,
      className: 'favorite_set_config__ancestor',
    }));
  }, []);

  // -- お気に入り商品読み込み（外注品はスキップして false を返す） --
  const handlerClickFavoriteBrandLoad = useCallback(async (id: string): Promise<boolean> => {
    const failToLoad = () => {
      dispatch(createOrderActions.setLoading(false));
      dispatch(dialogActions.pushMessage({
        title: '確認',
        message: ['データの読み込みに失敗しました'],
        buttons: [{
          label: 'OK',
          callback: () => {
            dispatch(dialogActions.pop());
          },
        }],
      }));
    };
    dispatch(createOrderActions.setLoading(true));
    dispatch(ordersActions.setParam({}));
    return new Promise<boolean>((resolve) => {
      dispatch(apiActions.run(
        new ApiFavoriteDataGet({ kijshopCd, favProductId: id }),
        {
          onSuccess: async (res: ResponseBase<FavoriteDataGetResponse>) => {
            if (!res?.body?.data?.xmlList?.length) {
              failToLoad();
              resolve(true);
              return;
            }
            // XMLの文字列から structure を生成
            /* レスポンスをXMLの種類毎に分割 */
            const resArr = [...res.body.data.xmlList];
            resArr.forEach((v) => {
              v.filename = v.filename.replace('.xml', '');
            });
            const orderInfoDataResArr: { filename: string, xml: string }[] = [];
            const orderPartsResArr: { filename: string, xml: string }[] = [];
            const orderPartsDataResArr: { filename: string, xml: string }[] = [];
            const orderPageResArr: { filename: string, xml: string }[] = [];
            const orderPageDataResArr: { filename: string, xml: string }[] = [];
            resArr.forEach((v) => {
              if (v.filename.includes('_orderInfoData_')) {
                orderInfoDataResArr.push(v);
              }
              if (v.filename.includes('_orderParts_')) {
                orderPartsResArr.push(v);
              }
              if (v.filename.includes('_orderPartsData_')) {
                orderPartsDataResArr.push(v);
              }
              if (v.filename.includes('_orderPage_')) {
                orderPageResArr.push(v);
              }
              if (v.filename.includes('_orderPageData_')) {
                orderPageDataResArr.push(v);
              }
            });
            /* 各XMLから index を取得 */
            const orderInfoDataMaterialArr: { xml: string, indexes: [string] }[] = [];
            const orderPartsMaterialArr: { xml: string, indexes: [string] }[] = [];
            const orderPartsDataMaterialArr: { xml: string, indexes: [string, string] }[] = [];
            const orderPageMaterialArr: { xml: string, indexes: [string, string] }[] = [];
            const orderPageDataMaterialArr: { xml: string, indexes: [string, string, string] }[] = [];
            let favShopOrderId = '';
            const errorCode = 'error';
            orderInfoDataResArr.forEach((v) => {
              const arr = v.filename.split('_');
              const len = arr.length;
              orderInfoDataMaterialArr.push({ xml: v.xml, indexes: [arr[len - 1]] });
              if (!favShopOrderId) {
                favShopOrderId = arr[1];
              } else if (favShopOrderId !== arr[1]) {
                favShopOrderId = errorCode;
              }
            });
            orderPartsResArr.forEach((v) => {
              const arr = v.filename.split('_');
              const len = arr.length;
              orderPartsMaterialArr.push({ xml: v.xml, indexes: [arr[len - 1]] });
              if (favShopOrderId !== arr[1]) {
                favShopOrderId = errorCode;
              }
            });
            orderPartsDataResArr.forEach((v) => {
              const arr = v.filename.split('_');
              const len = arr.length;
              orderPartsDataMaterialArr.push({ xml: v.xml, indexes: [arr[len - 2], arr[len - 1]] });
              if (favShopOrderId !== arr[1]) {
                favShopOrderId = errorCode;
              }
            });
            orderPageResArr.forEach((v) => {
              const arr = v.filename.split('_');
              const len = arr.length;
              orderPageMaterialArr.push({ xml: v.xml, indexes: [arr[len - 2], arr[len - 1]] });
              if (favShopOrderId !== arr[1]) {
                favShopOrderId = errorCode;
              }
            });
            orderPageDataResArr.forEach((v) => {
              const arr = v.filename.split('_');
              const len = arr.length;
              orderPageDataMaterialArr.push({ xml: v.xml, indexes: [arr[len - 3], arr[len - 2], arr[len - 1]] });
              if (favShopOrderId !== arr[1]) {
                favShopOrderId = errorCode;
              }
            });
            if (favShopOrderId === errorCode) {
              failToLoad();
              resolve(true);
              return;
            }
            /* 各XMLクラスを生成 */
            const orderInfoDataClassArr: OrderInfoDataXml[] = [];
            const orderPartsClassArr: OrderPartsXml[] = [];
            const orderPartsDataClassArr: OrderPartsDataXml[] = [];
            const orderPageClassArr: OrderPageXml[] = [];
            const orderPageDataClassArr: OrderPageDataXml[] = [];
            orderInfoDataMaterialArr.forEach((v) => {
              const xml = XmlFactory.createFromIndex({
                shopOrderId: favShopOrderId,
                data: { name: 'order-info-data', indexes: v.indexes },
              });
              xml.xml = v.xml;
              orderInfoDataClassArr.push(xml);
            });
            orderPartsMaterialArr.forEach((v) => {
              const xml = XmlFactory.createFromIndex({
                shopOrderId: favShopOrderId,
                data: { name: 'order-parts', indexes: v.indexes },
              });
              xml.xml = v.xml;
              orderPartsClassArr.push(xml);
            });
            orderPartsDataMaterialArr.forEach((v) => {
              const xml = XmlFactory.createFromIndex({
                shopOrderId: favShopOrderId,
                data: { name: 'order-parts-data', indexes: v.indexes },
              });
              xml.xml = v.xml;
              orderPartsDataClassArr.push(xml);
            });
            orderPageMaterialArr.forEach((v) => {
              const xml = XmlFactory.createFromIndex({
                shopOrderId: favShopOrderId,
                data: { name: 'order-page', indexes: v.indexes },
              });
              xml.xml = v.xml;
              orderPageClassArr.push(xml);
            });
            orderPageDataMaterialArr.forEach((v) => {
              const xml = XmlFactory.createFromIndex({
                shopOrderId: favShopOrderId,
                data: { name: 'order-page-data', indexes: v.indexes },
              });
              xml.xml = v.xml;
              orderPageDataClassArr.push(xml);
            });
            const parseFunc = (v: XmlClass<any>) => {
              return new Promise<void>((resolve) => {
                v.parse().then(resolve);
              });
            };
            const parseAll = async (arr: XmlClass<any>[]) => {
              for (let i = 0; i < arr.length; i++) {
                await parseFunc(arr[i]);
              }
            };
            await parseAll(orderInfoDataClassArr);
            await parseAll(orderPartsClassArr);
            await parseAll(orderPartsDataClassArr);
            await parseAll(orderPageClassArr);
            await parseAll(orderPageDataClassArr);
            // orderInfoDataClassArr.forEach((v) => v.build());
            // orderPartsClassArr.forEach((v) => v.build());
            // orderPartsDataClassArr.forEach((v) => v.build());
            // orderPageClassArr.forEach((v) => v.build());
            // orderPageDataClassArr.forEach((v) => v.build());
            /* 親商品を探査 */
            orderInfoDataClassArr.sort((a, b) => Number(a.indexes[0]) - Number(b.indexes[0]));
            const orderInfoData = orderInfoDataClassArr[0];
            // 外注品(オーダースタイル)由来のお気に入りは作成せずスキップ
            if (orderInfoData?.isOrderStyleOnly) {
              dispatch(createOrderActions.setLoading(false));
              resolve(false);
              return;
            }
            const optionOrderInfoDataArr: OrderInfoDataXml[] = [];
            for (let i = 1; i < orderInfoDataClassArr.length; i++) {
              optionOrderInfoDataArr.push(orderInfoDataClassArr[i]);
            }
            /* structureModel を生成 */
            const createOrderInfoDataStructure = (orderInfoData: OrderInfoDataXml) => {
              const orderInfoDataStructureModel: XmlStructureOrderInfoData = {
                xml: orderInfoData,
              };
              const partsPath = orderInfoData.xmlModel.lnwOrderInfoData.orderParts?.[0]?.$.path;
              const orderParts = orderPartsClassArr.find((v) => v.xmlUniqueName === partsPath);
              if (orderParts) {
                const orderPartsStructureModel: XmlStructureOrderParts = {
                  xml: orderParts,
                  partsData: [],
                };
                orderInfoDataStructureModel.parts = orderPartsStructureModel;
                orderParts.xmlModel.lnwOrderParts?.orderParts?.[0]?.data?.forEach((partsDataPath) => {
                  const orderPartsData = orderPartsDataClassArr.find((v) => v.xmlUniqueName === partsDataPath?.$.path);
                  if (orderPartsData) {
                    const orderPartsDataStructureModel: XmlStructureOrderPartsData = {
                      xml: orderPartsData,
                    };
                    const orderPagePath = orderPartsData.xmlModel.lnwOrderPartsData?.orderPage?.[0]?.$?.path;
                    const orderPage = orderPageClassArr.find((v) => v.xmlUniqueName === orderPagePath);
                    if (orderPage) {
                      const orderPageStructureModel: XmlStructureOrderPage = {
                        xml: orderPage,
                      };
                      orderPage.xmlModel.lnwOrderPage?.orderPage?.[0]?.data?.forEach((pageDataPath) => {
                        const orderPageData = orderPageDataClassArr.find((v) => v.xmlUniqueName === pageDataPath?.$.path);
                        if (orderPageData) {
                          if (orderPageStructureModel.pageData) {
                            orderPageStructureModel.pageData.push(orderPageData);
                          } else {
                            orderPageStructureModel.pageData = [orderPageData];
                          }
                        }
                      });
                      orderPartsDataStructureModel.page = orderPageStructureModel;
                    }
                    if (orderPartsStructureModel.partsData) {
                      orderPartsStructureModel.partsData.push(orderPartsDataStructureModel);
                    } else {
                      orderPartsStructureModel.partsData = [orderPartsDataStructureModel];
                    }
                  }
                });
              }
              return orderInfoDataStructureModel;
            };
            const parentOrderInfoStructure = createOrderInfoDataStructure(orderInfoData);
            const optionOrderInfoStructures: XmlStructureOrderInfoData[] = [];
            orderInfoDataClassArr.forEach((v) => {
              if (v.xmlUniqueName !== orderInfoData.xmlUniqueName) {
                optionOrderInfoStructures.push(createOrderInfoDataStructure(v));
              }
            });
            /* 画像情報を残すために order-page-data を保持 */
            const pageDataList: OrderPageDataXml[] = [];
            parentOrderInfoStructure.parts?.partsData?.forEach((partsData) => partsData.page?.pageData?.forEach((v) => pageDataList.push(v)));
            dispatch(createOrderActions.setFavData({
              parent: { id, pageDataList },
              option: [...optionOrderInfoDataArr].map((v) => createOrderInfoDataStructure(v)),
            }));
            if (parentOrderInfoStructure.xml.viewModel.descriptionInfo?.pageType) {
              parentOrderInfoStructure.xml.viewModel.descriptionInfo.pageType = undefined;
            }

            // runAllApi に投げる
            const data = convertResponseToOrderData(parentOrderInfoStructure, optionOrderInfoStructures, visibleCondition);
            // console.log(order);
            // const data = store.getState().orderData;
            // /* xmlから値を取得できない項目値を設定 */
            // if (order.itemDetail) {
            //   if (order.itemDetail.coverSelect?.value) {
            //     order.itemDetail.coverSelect.label = data.itemDetail.cover.coverType.find((v) => v.coverTypeId === order.itemDetail?.coverSelect?.value)?.coverTypeName || '';
            //   }
            //   if (order.itemDetail.boardSelect?.value) {
            //     order.itemDetail.boardSelect.label = data.itemDetail.board.boardInfo.find((v) => v.boardInfoId === order.itemDetail?.boardSelect?.value)?.boardInfoName || '';
            //   }
            //   if (order.itemDetail.designType1?.value) {
            //     order.itemDetail.designType1.label = data.itemDetail.designType1.hpsTppath.find((v) => v.hpsTppathNamePath === order.itemDetail?.designType1?.value)?.hpsTppathName || '';
            //   }
            //   if (order.itemDetail.designType2?.value) {
            //     order.itemDetail.designType2.label = data.itemDetail.designType2.hpsTppath.find((v) => v.dtemplId === order.itemDetail?.designType2?.value)?.hpsTpobjName || '';
            //     visibleCondition.getCreateOrderDisplay(order, data);
            //   }
            // }
            // visibleCondition.getCreateOrderDisplay(order, data);
            // dispatch(ordersActions.setParam(order));
            dispatch(ordersActions.runAllApi({ orders: data }, kijshopCd, false, true, () => {
              resolve(true);
            }));
            // dispatch(ordersActions.runAllApi({ orders: data }, kijshopCd, false, true));
            // setImportFav(true);
          },
          onError: () => {
            dispatch(createOrderActions.setLoading(false));
            failToLoad();
            resolve(true)
          },
        },
      ));
    })
  }, []);

  const handlerOptionLoad = useCallback(async () => {
    const { option } = store.getState().order;

    await Promise.all(
      option.map(async (op, index): Promise<void> => {
        const productNameId = op?.item?.value;
        const serviceId = op?.item?.serviceId ?? '';

        if (!productNameId) return;

        const parts1Promise = new Promise<void>((resolve) => {
          dispatch(
            apiActions.run(
              new ApiOptionParts1({ productNameId }),
              {
                onSuccess: (res) => {
                  const partsItemId = res.body.data?.items?.[0]?.itemId ?? '';
                  const cover = [...store.getState().orderData.option.cover];
                  cover[index] = { itemId: partsItemId };
                  dispatch(ordersDataActions.updateOption({ cover }));

                  if (!partsItemId) {
                    resolve();
                    return;
                  }

                  dispatch(
                    apiActions.run(
                      new ApiLaminates({ itemId: partsItemId, productNameId }),
                      {
                        onSuccess: (laminateRes) => {
                          const laminates = laminateRes?.body?.data?.laminate ?? [];

                          dispatch(
                            ordersDataActions.setOptionLaminate({
                              laminate: { laminate: laminates },
                              index,
                            }),
                          );

                          if (laminates.length === 1) {
                            dispatch(
                              ordersActions.option.setLaminate(
                                laminates[0].laminateId,
                                index,
                                laminates[0].laminateName,
                              ),
                            );
                          }

                          resolve();
                        },
                        onError: () => resolve(),
                      },
                      { ignoreSystemError: true },
                    ),
                  );
                },
                onError: () => resolve(),
              },
              { ignoreSystemError: true },
            ),
          );
        });

        const foilPromise = new Promise<void>((resolve) => {
          dispatch(
            apiActions.run(
              new ApiOptionFoilStampings({ productNameId }),
              {
                onSuccess: (res) => {
                  dispatch(
                    ordersDataActions.setOptionFoilStamping({
                      foilStamping: {
                        leafColor: res?.body?.data?.leafColor ?? [],
                      },
                      index,
                    }),
                  );
                  resolve();
                },
                onError: () => {
                  dispatch(
                    ordersDataActions.setOptionFoilStamping({
                      foilStamping: { leafColor: [] },
                      index,
                    }),
                  );
                  resolve();
                },
              },
            ),
          );
        });

        const detailPromise = new Promise<void>((resolve) => {
          dispatch(
            apiActions.run(
              new ApiProductDetail({
                productNameId,
                serviceId,
                parentFlg: '2',
              }),
              {
                onSuccess: (res) => {
                  dispatch(
                    ordersDataActions.setOptionProductDetail({
                      data: res.body.data ?? null,
                      index,
                    }),
                  );

                  const partsCount = Number(res.body.data?.itemCount);

                  if (partsCount < 2) {
                    resolve();
                    return;
                  }

                  const PartsApi = partsCount >= 3 ? ApiOptionParts3 : ApiOptionParts2;

                  dispatch(
                    apiActions.run(new PartsApi({ productNameId }), {
                      onSuccess: (r) => {
                        const genuine = [...store.getState().orderData.option.genuine];
                        genuine[index] = {
                          itemId: r.body.data?.items?.[0]?.itemId ?? '',
                        };
                        dispatch(ordersDataActions.updateOption({ genuine }));
                        resolve();
                      },
                      onError: () => resolve(),
                    }),
                  );
                },
                onError: () => resolve(),
              },
            ),
          );
        });

        const pageTypePromise = new Promise<void>((resolve) => {
          dispatch(
            apiActions.run(
              new ApiPageDataTypes({
                productNameId,
                serviceId,
                parentFlg: '2',
              }),
              {
                onSuccess: (res) => {
                  const pageDataTypes = res.body.data?.pageDataTypes ?? [];
                  const currentOption = store.getState().order.option[index];

                  if (pageDataTypes.length > 0 && !currentOption?.descriptionLocations) {
                    dispatch(
                      ordersActions.option.setDescriptionLocations(
                        [pageDataTypes[0].pageDataTypeId],
                        index,
                      ),
                    );
                  }

                  resolve();
                },
                onError: () => resolve(),
              },
            ),
          );
        });

        const endpaperPromise = new Promise<void>((resolve) => {
          dispatch(
            apiActions.run(
              new ApiEndpaper({
                productNameId,
                parentFlg: '2',
              }),
              {
                onSuccess: (res) => {
                  dispatch(
                    ordersDataActions.setOptionAdditional({
                      data: res?.body?.data
                        ? { ...res.body.data, itemId: productNameId }
                        : null,
                      index,
                    }),
                  );
                  resolve();
                },
                onError: () => resolve(),
              },
            ),
          );
        });

        await Promise.all([parts1Promise, foilPromise, detailPromise, pageTypePromise, endpaperPromise]);
      }),
    );
  }, [order]);

  const showSetFetchError = useCallback(() => {
    setCreating(false);
    dispatch(dialogActions.pushMessage({
      title: '確認',
      message: ['セット情報の取得に失敗しました'],
      buttons: [{ label: 'OK', callback: () => dispatch(dialogActions.pop()) }],
    }));
  }, []);

  // -- OKボタン --
  const handlerClickOk = useCallback(() => {
    if (!selectSet) return;
    setCreating(true);
    dispatch(
      apiActions.run(
        new ApiSetFavoriteGet(selectSet.id, { kijshopCd }),
        {
          onSuccess: async (res: ResponseBase<SetFavoriteItemResponse>) => {
            const item = res.body.data;
            if (item) {
              const favoriteItem: FavoriteSetItem = {
                id: item.id,
                name: item.name,
                type: 'set',
                level: 1,
                parentId: '',
                children: [],
                favProductIds: (item.favProducts ?? []).map(v => v.id),
              };
              setTotalOrderCount(favoriteItem.favProductIds.length);
              let skippedCount = 0;
              for (const favProductId of favoriteItem.favProductIds) {
                const loaded = await handlerClickFavoriteBrandLoad(favProductId);
                if (!loaded) {
                  // 外注品(旧フジ発注方式)はスキップ
                  skippedCount += 1;
                  setCreateOrderCount(prev => prev + 1);
                  continue;
                }
                await handlerOptionLoad();
                await handlerClickSaveToFinish();
                setCreateOrderCount(prev => prev + 1);
              }
              setCreating(false);
              dispatch(ordersDataActions.resetData());
              dispatch(ordersActions.setParam({}));
              dispatch(dialogActions.pop());
              const savedCount = favoriteItem.favProductIds.length - skippedCount;
              const resultMessage = (savedCount === 0 && skippedCount > 0)
                ? [
                  '対象のセット商品は「旧フジ発注方式」専用です',
                  'クラウドフォルダからご利用ください',
                ]
                : skippedCount > 0
                  ? [
                    '注文を保存しました',
                    `（${skippedCount}件は「旧フジ発注方式」のためスキップされました）`,
                  ]
                  : ['注文を保存しました'];
              dispatch(dialogActions.pushMessage({
                title: '確認',
                message: resultMessage,
                buttons: [{ label: 'OK', callback: () => dispatch(dialogActions.pop()) }],
              }));
            } else {
              showSetFetchError();
            }
          },
          onError: () => {
            showSetFetchError();
          },
        },
        { apiName: `favoriteSet:get:${selectSet.id}` } // 連打対策（最新のみ採用）
      )
    );
  }, [selectSet, setDataList]);

  // -- 一覧更新とダイヤログ閉じる --
  const refreshList = useCallback(() => {
    handlerCreateListData();
    dispatch(dialogActions.pop())
  }, []);

  type SetFavProductListApi =
    ResponseBase<{ data: { setFavProductList: SetFavoriteItemListResponse } }>;

  // -- お気に入り商品セット一覧取得 --
  const handlerCreateListData = useCallback((content?: FavoriteSetItem) => {
    setLoading(true);
    dispatch(apiActions.run(
      new ApiSetFavoriteListGet ({kijshopCd}),
      {
        onSuccess: (res: SetFavProductListApi) => {
          const d = res.body.data as any;

          // サーバーの返し方が「ラップ型」でも「素の配列」でも拾えるように吸収
          const rawList: SetFavoriteItemListResponse = Array.isArray(d)
            ? d
            : (d?.setFavProductList ?? []);

          // 画面表示用の形式に変換
          const setFavoriteList: FavoriteSetItem[] = rawList.map(({ id, name }) => ({
            id,
            name,
            type: 'set',
            level: 1,
            parentId: '',
            children: [],
            favProductIds: [],
          }))

          // 名前のアルファベット順でソート
          setFavoriteList.sort((a, b) => a.name.localeCompare(b.name, 'ja'));

          // 変換・ソート済みのリストをstateに保存
          setFavoriteDataList(setFavoriteList);

          setLoading(false);
          setLoadingInit(false);
        },
        onError: () => {
          setFavoriteDataList([]);
          setLoading(false);
          setLoadingInit(false);
        },
      },
    ));
  }, [dispatch, kijshopCd]);
  // - Effect -
  useEffect(() => {
    handlerCreateListData();
  }, []);

  // -- 保存して終了 --
  const handlerClickSaveToFinish = async () => {
    const order = store.getState().order;
    const data = store.getState().orderData;
    return new Promise<void>(resolve => {
    // if (connecting) {
    //   return;
    // }
    // lockCheck!
      const createDate = DateFormatter.date2str(new Date(), 'YYYYMMDD_HHmmSS', '/');
      dispatch(orderLockActions.check(
        kijshopCd, shopOrderId,
        {
          yes: () => {
            // 必須項目バリデーション
            const showDialog = (v: string) => {
              dispatch(dialogActions.pushMessage({
                title: '確認',
                message: [`${v}は入力必須です`],
                buttons: [
                  {
                    label: 'OK',
                    callback: () => {
                      resolve();
                      dispatch(dialogActions.pop());
                    },
                  },
                ],
              }));
            };
            if (data.option.optionProductGroupRules?.optionGroupRule?.length) {
              let flag: boolean = false;
              let arr: OptionRequireAlert[] = [];
              data.option.optionProductGroupRules.optionGroupRule.forEach((v) => {
                flag = false;
                if (v.optionProductGroupName === 'setAny') {
                  v.optionProductName.forEach((item) => {
                    if (!flag) {
                      if (order.option.find((op) => op?.item?.value === item.optionProductNameId)) {
                        flag = true;
                        arr = arr.filter(elm => elm.groupId !== v.optionProductGroupRuleId);
                      } else {
                        const alertData: OptionRequireAlert = { groupId: v.optionProductGroupRuleId, alertList: [] };
                        alertData.alertList.push(data.option.optionItem.optionProduct.find((p) => p.optionProductNameId === item.optionProductNameId)?.optionProductName || '');
                        const target = arr.find(elm => elm.groupId === alertData.groupId);
                        if (target) {
                          target.alertList.push(alertData.alertList?.[0] ?? '');
                        } else {
                          arr.push(alertData);
                        }
                      }
                    }
                  });
                }
              });
              if (arr.filter((v) => v?.alertList.length).length) {
                const addBaseMessage = (message: string[], isOnly: boolean) => {
                  const baseMessage = isOnly ? '以下のオプションを選択する必要があります。' : '以下のオプションの内、いずれかを選択する必要があります。';
                  message.length ? message.push('', baseMessage, '') : message.push(baseMessage, '');
                };
                const createMessage = () => {
                  let message: string[] = [];
                  for (const arrElement of arr) {
                    if (arrElement.alertList) {
                      addBaseMessage(message, arrElement.alertList.length === 1)
                      message.push(...[...arrElement.alertList.filter((v) => v)].map((v) => `・${v}`),)
                    }
                  }
                  return message;
                };
                dispatch(dialogActions.pushMessage({
                  title: '確認',
                  message: createMessage(),
                  buttons: [{
                    label: 'OK',
                    callback: () => {
                      resolve();
                      dispatch(dialogActions.pop());
                    },
                  }],
                }));
                return;
              }
            }
            // const display = displayItem(order, data, kijshopCd);
            const display = visibleCondition.getCreateOrderDisplay(order, data);
            if (display.descriptionInfo) {
              const description = order.descriptionInfo;
              if (
                (
                  (description.name)
                  || (description.date?.value)
                  || (description.photographLocation)
                ) && !description.descriptionLocations?.length
              ) {
                dispatch(dialogActions.pushMessage({
                  title: '確認',
                  message: [
                    '商品記載情報の名前、日付、場所のいずれかが入力されている場合、',
                    '記載箇所のチェックが必要です。',
                    '',
                    '記載が必要ない場合',
                    '名前、日付、場所の入力を削除してください。',
                  ],
                  buttons: [{
                    label: 'OK',
                    callback: () => {
                      resolve();
                      dispatch(dialogActions.pop());
                    },
                  }],
                }));
                return;
              }
            }
            const optionCheck = order.option.find((v) => v.tag?.value && !v.item?.value);
            if (optionCheck) {
              dispatch(dialogActions.pushMessage({
                title: '確認',
                message: [
                  '商品情報ー商品詳細ーオプションー商品タグが選択されている場合、',
                  '商品情報ー商品詳細ーオプションー商品選択は入力必須です。',
                ],
                buttons: [{
                  label: 'OK',
                  callback: () => {
                    resolve();
                    dispatch(dialogActions.pop());
                  },
                }],
              }));
              return;
            }
            const errorMessage: string[] = [];
            const arr: CreateOrderItemData[] = [];
            if (order.itemInfo.category) {
              arr.push(...itemDetailItemData(order, data, visibleCondition));
            }
            if (display.cover) {
              arr.push(...coverItemData(order, data, visibleCondition));
            }
            if (display.genuine) {
              arr.push(...genuineItemData(order, data, visibleCondition));
            }
            if (display.descriptionInfo) {
              arr.push(...descriptionInfoItemData(order, data, visibleCondition));
            }
            if (display.option) {
              arr.push(...optionItemData(order, data, visibleCondition));
            }
            let alert = false;
            arr.forEach((v) => {
              if (v.validation && !v.validation?.(v.value)) {
                alert = true;
                dispatch(dialogActions.pushMessage({
                  title: '確認',
                  message: [
                    v.categorize,
                    '上記項目にエラーがあります。',
                    'ご確認ください。',
                  ],
                  buttons: [{
                    label: 'はい',
                    callback: () => {
                      resolve();
                      dispatch(dialogActions.pop());
                    },
                  }],
                }));
                return;
              }
              if (v.display && !v.optional && !v.value) {
                errorMessage.push(v.categorize);
              }
            });
            if (alert) {
              resolve();
              return;
            }
            // const itemDetailDisplay = itemDetailDisplayItem(order, data);
            const itemDetailDisplay = visibleCondition.itemDetailOrderDisplay
            console.log(order);
            if (!order.itemInfo.category.value) {
              showDialog('商品情報-カテゴリ');
              resolve();
              return;
            }
            if (itemDetailDisplay.cover && !order.itemDetail.coverSelect.value) {
              showDialog('商品情報-商品詳細-表紙選択');
              resolve();
              return;
            }
            if (itemDetailDisplay.coverColor && !order.itemDetail.coverColorSelect.value) {
              showDialog('商品情報-商品詳細-表紙色選択');
              resolve();
              return;
            }
            if (itemDetailDisplay.item && !order.itemDetail.itemSelect.value) {
              showDialog('商品情報-商品詳細-商品選択');
              resolve();
              return;
            }
            if (itemDetailDisplay.board && !order.itemDetail.boardSelect.value) {
              showDialog('商品情報-商品詳細-部材選択');
              resolve();
              return;
            }
            if (itemDetailDisplay.orderMethod && !order.itemDetail.orderMethod.value) {
              showDialog('商品情報-商品詳細-注文方法選択');
              resolve();
              return;
            }
            const save = (isComp: boolean) => {
              // setSaving(true);
              const callback = {
                success: () => {
                  // setSaving(false);
                  resolve();
                },
                error: () => {
                  // setSaving(false);
                  resolve();
                  // dispatch(dialogActions.pushMessage({
                  //   title: 'エラー',
                  //   message: ['注文の作成に失敗しました'],
                  //   buttons: [
                  //     {
                  //       label: 'OK',
                  //       callback: () => {
                  //         resolve();
                  //         dispatch(dialogActions.pop());
                  //       },
                  //     },
                  //   ],
                  // }));
                },
              };
              dispatch(xmlActions.order({ shopOrderId, kijshopCd, callback }).create(order, data, visibleCondition, isComp, createDate));
            };
            if (errorMessage.length) {
              dispatch(dialogActions.pushMessage({
                title: '確認',
                message: [
                  ...errorMessage,
                  'は入力必須です。',
                  '',
                  '上記項目の入力が不十分です。',
                  '作業内容を保存して前のページに戻ります。',
                  'よろしいですか？',
                ],
                buttons: [
                  {
                    label: 'いいえ',
                    callback: () => {
                      resolve();
                      dispatch(dialogActions.pop());
                    },
                  },
                  {
                    label: 'はい',
                    callback: () => {
                      resolve();
                      dispatch(dialogActions.pop());
                      save(false);
                    },
                  },
                ],
              }));
            } else {
              resolve();
              save(true);
            }
          },
          no: () => {
            resolve();
            dispatch(orderLockActions.setId(''));
            dispatch(push(RoutingPath.cnv.orders({ kijshopCd })));
          },
        },
      ));
    })
  };

  const totalCount = useMemo(() => {
    let num = 0;
    childrenOpenCountArr.forEach((v) => {
      num += v || 0;
    });
    return num + favoriteDataList.length;
  }, [childrenOpenCountArr, favoriteDataList.length]);

  //枠をしたまで表示するためにプレイスホルダーを追加
  const MIN_ROWS = 11;
  const itemsToRender = useMemo(() => {
    console.log(favoriteDataList);
    const placeholders = Math.max(0, MIN_ROWS - favoriteDataList.length);
    const ph = Array.from({ length: placeholders }, (_, i) => ({
      id: `ph-${i}`,
      name: '',
      type: 'placeholder' as const,
      level: 1,
      parentId: '',
      children: [],
    }));
    return [...favoriteDataList, ...ph];
  }, [favoriteDataList]);

  return (
    <div className="dialog_contents favorite_set_config">
      <div className="dialog_contents__body favorite_set_config__table">
        <div className="favorite_set_config__table__inner">
          <div className="favorite_set_config__table__header">お気に入りセット商品名</div>
          <div className="favorite_set_config__table__body">
            {itemsToRender.map((item) => (
              <ChildContent
                key={item.id}
                content={item as FavoriteSetItem}
                selected={item.id === selectedId && item.type !== 'placeholder'}
                onClick={() => {
                  if (item.type === 'placeholder') return; // 空行は反応させない
                  setSelectedId(item.id);
                  dispatch(favoriteSetActions.setSelectSet(item));
                }}
              />
            ))}
          </div>
        </div>
      </div>
      <div className="dialog_contents__footer">
        <div className="dialog_contents__footer__left">
          <Button
            label={closeButtonLabel ? closeButtonLabel : '閉じる'}
            onClick={closeButtonCallback ? closeButtonCallback : handlerClickClose}
          />
        </div>
        <div className="dialog_contents__footer__center">
          <Button
            label="削除"
            color="danger"
            onClick={handlerCLickDelete}
            disabled={!selectSet} // 選択の有無で活性化の処理を行っているので、そのまま使える
          />
          {props.mode === 'disp'? (
            <>
              <Button
                label="編集"
                onClick={handlerClickSetUpdate} // 編集用APIをつないだ別の関数を呼ぶ
                disabled={!selectSet}
              />
              <Button
                label="セット登録"
                onClick={handlerClickSetRegister} // 登録用APIをつないだ別の関数を呼ぶ
              />
            </>
          ): (<></>) }
        </div>
        <div className="dialog_contents__footer__right">
          {props.mode === 'select'? (
            <Button
              label="OK"
              onClick={handlerClickOk}
              disabled={!selectSet}
            />
          ): (<></>) }
        </div>

      </div>
      {loadingInit ? <LoadingPopup key={`fav-loading`} /> : <></>}
      {!loadingInit && loading ? <LoadingPopup key={`fav-loading`} label={'更新中です'} /> : <></>}
      {creating ? (<LoadingPopup label={`注文作成中です... (${createOrderCount}/${totalOrderCount})`} />) : (<></>)}
    </div>
  );
};
